<template>
	<div>
		<bread-crumbs
			:bread-crumbs="{'/bo/claimstatusdescriptions': $gettext('Claim Status Descriptions')}"
			:current-title="$gettext('Adjust Description')"
		/>
		<v-card>
			<v-card-title class="d-flex align-center">
				<translate>Adjust Description</translate>
			</v-card-title>
			<v-card-text>
				<div v-if="claimstatusdescription">
					<v-row>
						<v-col>
							<v-select
								v-if="claimstatuses"
								v-model="claimstatusdescription.claimstatus"
								:label="$gettext('Claim Status')"
								:items="claimstatuses"
								item-value="id"
								item-title="name"
								:disabled="!updatePermission"
								variant="outlined"
							/>
						</v-col>
						<v-col>
							<v-select
								v-model="claimstatusdescription.claimType"
								:label="$gettext('Claim Type')"
								:items="claimTypes"
								item-value="value"
								item-title="text"
								:disabled="!updatePermission"
								variant="outlined"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field
								v-model="claimstatusdescription.claimDescription"
								:label="$gettext('Claim Description')"
								:disabled="!updatePermission"
								variant="outlined"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-select
								v-if="domains"
								v-model="claimstatusdescription.domain"
								:label="$gettext('Domain')"
								:items="domains"
								item-value="id"
								item-title="name"
								:disabled="!updatePermission"
								variant="outlined"
							/>
						</v-col>
						<v-col>
							<v-select
								v-if="languages"
								v-model="claimstatusdescription.language"
								:label="$gettext('Language')"
								:items="languages"
								item-value="id"
								item-title="name"
								:disabled="!updatePermission"
								variant="outlined"
							/>
						</v-col>
					</v-row>
				</div>
				<v-row>
					<v-col>
						<label class="v-label theme--light"><translate>Text</translate></label>
						<hr>
						<textarea
							id="body"
							required
							variant="outlined"
						/>
						<hr>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="goBack">
					<translate>Back</translate>
				</v-btn>
				<v-btn
					v-if="updatePermission"
					color="primary"
					@click="submit"
				>
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import * as ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-smarty';
import 'ace-builds/src-noconflict/theme-tomorrow';
import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError,
	inform,
} from 'laravel-front-library';

export default {
	name: 'ClaimStatusDescriptionEdit',

	data () {
		return {
			claimstatusdescription: null,

			claimTypes: [
				{
					value: '',
					text: this.$gettext('Both')
				},
				{
					value: 'damage',
					text: this.$gettext('Damage')
				},
				{
					value: 'loss',
					text: this.$gettext('Loss')
				},
			],

			claimstatuses: null,
			languages: null,
			domains: null,

			updatePermission: localStorage.getItem('permissions').includes('claimstatusdescription.update')
		};
	},

	async mounted () {
		this.getClaimStatusDescription();
		this.getSelectOptions();
	},

	methods: {
		/**
		 *
		 */
		goBack () {
			window.location.href = '/bo/claimstatusdescriptions';
		},

		/**
		 * Retrieve the options for claimstatus, language, and domain select boxes.
		 *
		 * @returns {void}
		 */
		getSelectOptions () {
			axios.get('/api/v0/claimstatuses').then(({
				data: data
			}) => {
				this.claimstatuses = data;
			}).catch((e) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(e);
			});

			axios.get('/api/v0/languages/supported').then(({
				data: data
			}) => {
				this.languages = data;
			}).catch((e) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(e);
			});

			axios.get('/api/v0/domains').then(({
				data: data
			}) => {
				this.domains = data;
			}).catch((e) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(e);
			});
		},

		/**
		 * Retrieve the current claimstatusdescription.
		 *
		 * @returns {void}
		 */
		async getClaimStatusDescription () {
			await axios.get('/api/v0/claimstatusdescriptions', {
				params: {
					id: (new URLSearchParams(window.location.search.substring(1))).get('id')
				}
			}).then(({
				data: data
			}) => {
				if (data) {
					const csd = data[0];

					this.claimstatusdescription = {
						id: csd.id,
						claimstatus: csd.claimstatus.id,
						claimDescription: csd.claimDescription,
						claimType: csd.claimType,
						domain: csd.domain.id,
						language: csd.language.id,
						text: csd.description
					};
				} else {
					displayError(this.$gettext('Something has gone wrong during get csd request'));
				}
			});

			this.editor = ace.edit('body');
			this.editor.setTheme('ace/theme/tomorrow');
			this.editor.getSession().setMode('ace/mode/smarty');
			this.editor.resize();
			this.editor.setReadOnly(!this.updatePermission);
			this.editor.setValue(this.claimstatusdescription.text, 1);
		},

		/**
		 * Update the current claimstatusdescription
		 *
		 * @returns {void}
		 */
		submit () {
			this.claimstatusdescription.text = this.editor.getValue();

			axios.put(`/api/v0/claimstatusdescriptions?id=${this.claimstatusdescription.id}`, this.claimstatusdescription).then(() => {
				inform(this.$gettext('Description updated.'));
			}).catch((error) => {
				if (error.response.status === 500) {
					displayError(this.$gettext('Description could not be created.'));
					window.captureException(error);
				}
				displayError(error.response.data);
			});
		}
	}
};
</script>
